import { useQueryUserEHR } from '@/hooks/query/integrations/useQueryUserEHR';

export const useLegacyIntegrationSource = () => {
  const {
    data: userEhrProvider,
    isPending: isLegacySourcePending,
    isError: isLegacySourceError,
    fetchStatus: isLegacySourceFetchStatus,
    dataUpdatedAt: legacySourceDataUpdatedAt,
  } = useQueryUserEHR((data) => data.ehr_profile?.ehr_provider);

  return {
    userEhrProvider,
    hasLegacyEhrProfile: Boolean(userEhrProvider),
    isLegacySourcePending,
    isLegacySourceError,
    // "Actually resolving": `isPending` is also true forever while the query
    // is disabled (no auth, region, or kinde user id — fetchStatus stays
    // `idle`) or paused offline (fetchStatus `paused`, while the
    // `networkMode: 'always'` session queries still load).
    // `fetchStatus === 'fetching'` is the comparison that excludes both: a
    // disabled query is never fetching and a paused fetch is `paused`, not
    // `fetching`, so an offline WebView or cold start does not hold the
    // loading canvas forever. Self-limits to the first settle because
    // `isPending` ends with the first success or error, so a later refetch
    // of a live query cannot re-hold a caller.
    // `isError` also fires on a failed background refetch with cached data
    // still present; only an initial load that never succeeded
    // (`dataUpdatedAt === 0`) counts as a loading error — the post-`select`
    // data is `undefined` for the no-legacy-profile cohort, so TanStack's own
    // `isLoadingError` would misread any refetch error there.
    isLegacySourceLoading:
      isLegacySourcePending && isLegacySourceFetchStatus === 'fetching',
    isLegacySourceLoadingError: isLegacySourceError && legacySourceDataUpdatedAt === 0,
  };
};
